/*
 * only client side
 */
import { INTERNAL_HOST } from '@config/index';
import { fetcher } from '@utils/fetcher';

const fetchNext = (url, options, lang = 'pl') => {
  const headers = {
    'content-type': 'application/json',
    ...options.headers,
  };
  return fetcher(`${INTERNAL_HOST}/api/${lang}/${url}`, {
    ...options,
    headers,
  });
};

export default fetchNext;
